import { db } from '../config/firebase';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

// ══════════════════════════════════════════════════════════════════════
//  BASELINE FORMS — hifadhi ya Firestore
//  ID moja kwa kila mtoto + aina ya fomu (baseline/endline), ili fomu
//  isirudiwe kwa bahati mbaya. Kila SEHEMU (A–D) inahifadhiwa KIVYAKE
//  kama operesheni yake ya setDoc(merge:true) — hii ndiyo "kusave draft":
//  mwalimu akijaza Sehemu A leo na kocha akaja kujaza Sehemu B wiki
//  ijayo, hakuna anayepoteza kazi ya mwenzake, na hakuna anayelazimika
//  kumaliza fomu nzima kwa kukaa kimoja.
// ══════════════════════════════════════════════════════════════════════

const COLLECTION = 'baselineForms';

export function baselineFormId(memberId, formType) {
  return `${memberId}__${(formType || 'baseline').toLowerCase()}`;
}

export async function fetchBaselineForm(memberId, formType) {
  const id = baselineFormId(memberId, formType);
  const snap = await getDoc(doc(db, COLLECTION, id));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

// Je, fomu hii tayari ipo? Inatumika kuamua kama tuandike createdAt
// (mara ya kwanza tu) ili isibadilike kila mtu anaposave sehemu yake.
async function formExists(id) {
  const snap = await getDoc(doc(db, COLLECTION, id));
  return snap.exists();
}

// Header (childNo, dateFilled, termUsed) — haihitaji mtu wa sehemu maalum
export async function saveBaselineHeader({ memberId, formType, header, author }) {
  const id = baselineFormId(memberId, formType);
  const isNew = !(await formExists(id));
  await setDoc(doc(db, COLLECTION, id), {
    memberId, formType: formType || 'baseline',
    header: header || {},
    updatedAt: serverTimestamp(),
    lastEditedBy: author?.uid || '',
    lastEditedByName: author?.name || '',
    ...(isNew ? { createdAt: serverTimestamp() } : {}),
  }, { merge: true });
  return id;
}

// Sehemu moja (A/B/C/D) — operesheni huru, haiguswi na sehemu nyingine
export async function saveBaselineSection(memberId, formType, sectionId, sectionValues, completedByName, author) {
  const id = baselineFormId(memberId, formType);
  const isNew = !(await formExists(id));
  await setDoc(doc(db, COLLECTION, id), {
    memberId, formType: formType || 'baseline',
    values: { [sectionId]: sectionValues || {} },
    sectionMeta: {
      [sectionId]: {
        completedByName: completedByName || '',
        completedAt: serverTimestamp(),
        completedByUid: author?.uid || '',
      },
    },
    updatedAt: serverTimestamp(),
    lastEditedBy: author?.uid || '',
    lastEditedByName: author?.name || '',
    ...(isNew ? { createdAt: serverTimestamp() } : {}),
  }, { merge: true });
  return id;
}
